import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvMicroPeople } from '../config/env.micro.people';
import { PEOPLE_ENV } from '../config/micros-env.tokens';

function isEmployeeHierarchyMutation(req: { method: string; url: string }): boolean {
  const path = req.url.split('?')[0];
  const m = req.method.toUpperCase();
  if (!path.includes('/api/v1/employee-hierarchies')) {
    return false;
  }
  if (m === 'POST' && /\/api\/v1\/employee-hierarchies$/.test(path)) {
    return true;
  }
  if (m === 'PUT' && /\/api\/v1\/employee-hierarchies\/\d+$/.test(path)) {
    return true;
  }
  return false;
}

export const employeeHierarchyMutationApiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  const env = inject(PEOPLE_ENV, { optional: true }) as EnvMicroPeople | null | undefined;
  const key = env?.xApiKey;
  if (!key || !isEmployeeHierarchyMutation(req)) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { 'x-api-key': key } }));
};
